import React from "react";

export default ({ title }) => {
  return (
    <div>
      <h3 className="title has-text-centered is-spaced has-text-grey">{title}</h3>
      <p className="subtitle has-text-weight-light has-text-centered is-size-5 has-text-grey">
        Confirm infomation
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/page/HeaderText.js